<tg-row>
    <tg-col sm="12" md="12" lg="8">
        <div class="motors-vehicle-details-header-section--background">
            <tg-row>
                <tg-col
                    sm="3"
                    class="motors-vehicle-details-header-section__image-container"
                >
                    <div
                        class="motors-vehicle-details-header-section__boat-image"
                    >
                        <motors-illustration-boat
                            class="motors-vehicle-details-header-section__boat-image__boat-image-svg"
                        ></motors-illustration-boat></div
                ></tg-col>
                <tg-col
                    sm="9"
                    class="motors-vehicle-details-header-section__text-container"
                >
                    <p class="p-lead-copy">
                        We’ve made selling simpler<br />
                        <label class="view-price-options">
                            View our <a href="https://help.trademe.co.nz/hc/en-us/articles/360032010952-Motors-fees#h_5872a85f-8c57-41ae-9768-d399809eb5a5" target="_blank">listing options and prices</a>.
                        </label>
                    </p>
                </tg-col>
            </tg-row>
        </div>
    </tg-col>
</tg-row>
